import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

export enum PhoneNumberFormFields {
  Phone = 'phone',
}

export interface IPhoneNumberFormValues {
  [PhoneNumberFormFields.Phone]: string;
}

export const phoneNumberFormValidationSchema = Yup.object<
  Yup.ObjectSchema<{ phone: string }>
>().shape({
  phone: Yup.string()
    .required('Phone is required')
    .test('isValidPhoneNumber', 'Invalid phone number', (value) => {
      if (!value) {
        return false;
      }
      return isValidPhoneNumber(value, {
        defaultCountry: 'US',
      });
    }),
});
